import * as yup from "yup";

//Form Login
export const loginForm = {
  fields: [
    {
      name: "username",
      label: "User Name",
      as: "input",
      type: "text",
      column: 12,
      useLabel: false,
      rules: yup.string().required().trim(),
    },
    {
      name: "password",
      label: "Password",
      as: "input",
      type: "password",
      column: 12,
      useLabel: false,
      rules: yup.string().required().trim(),
    },
  ],
};

//Form New User Profile
export const userForm = {
  fields: [
    {
      name: "username",
      label: "Username",
      as: "input",
      type: "text",
      column: 12,
      useLabel: true,
      rules: yup.string().required().trim(),
    },
    {
      name: "password",
      label: "Password",
      as: "input",
      type: "password",
      column: 12,
      useLabel: true,
      rules: yup.string().required().trim(),
    },
    {
      name: "phone",
      label: "Phone",
      as: "input",
      type: "text",
      column: 12,
      useLabel: true,
      rules: yup.string().required().trim(),
    },
    {
      name: "email",
      label: "Email",
      as: "input",
      type: "email",
      column: 12,
      useLabel: true,
      rules: yup.string().email().required().trim(),
    },
    {
      name: "pin",
      label: "Pin",
      as: "input",
      type: "text",
      column: 12,
      useLabel: true,
      rules: yup
        .number()
        .test(
          "len",
          "Please enter a pin with 4-6 digits",
          (val) => val.toString().length >= 4 && val.toString().length <= 6,
        )
        .required(),
    },
  ],
};

//Form New Permission
export const permissionForm = {
  fields: [
    {
      name: "name",
      label: "Name",
      as: "input",
      type: "text",
      column: 12,
      useLabel: true,
      rules: yup.string().required().trim(),
    },
    {
      name: "description",
      label: "Description",
      as: "textarea",
      type: "text",
      column: 12,
      useLabel: true,
      rules: yup.string().required().trim(),
    },
    {
      name: "endpoint",
      label: "Endpoint",
      as: "input",
      type: "text",
      column: 6,
      useLabel: true,
      rules: yup.string().required().trim(),
    },
    {
      name: "path",
      label: "Path",
      as: "input",
      type: "text",
      column: 6,
      useLabel: true,
      rules: yup.string().required().trim(),
    },
    {
      name: "method",
      label: "Method",
      as: "input",
      type: "text",
      column: 4,
      useLabel: true,
      rules: yup.string().required().trim(),
    },
    {
      name: "action",
      label: "Action",
      as: "input",
      type: "text",
      column: 4,
      useLabel: true,
      rules: yup.string().required().trim(),
    },
    {
      name: "controller",
      label: "Controller",
      as: "input",
      type: "text",
      column: 4,
      useLabel: true,
      rules: yup.string().required().trim(),
    },
    {
      name: "aplicacionName",
      label: "Application Name",
      as: "input",
      type: "text",
      column: 12,
      useLabel: true,
      rules: yup.string().required().trim(),
    },
  ],
};

//Form New Role
export const rolesForm = {
  fields: [
    {
      name: "name",
      label: "Name",
      as: "input",
      type: "text",
      column: 12,
      useLabel: true,
      rules: yup.string().required().trim(),
    },
    {
      name: "description",
      label: "Description",
      as: "textarea",
      type: "text",
      column: 12,
      useLabel: true,
      rules: yup.string().required().trim(),
    },
  ],
};

//Form New Role
export const userFieldForm = {
  fields: [
    {
      name: "name",
      label: "Name",
      as: "input",
      type: "text",
      column: 12,
      useLabel: true,
      rules: yup.string().required().trim(),
    },
    {
      name: "description",
      label: "Description",
      as: "textarea",
      type: "text",
      column: 12,
      useLabel: true,
      rules: yup.string().required().trim(),
    },
  ],
};
